import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Registrations from "@/pages/admin/Registrations";
import Activity from "@/pages/admin/Activity";
import Assiduite from "@/pages/shared/assiduite/Assiduite";
import { ParentEntry, ParentFiche, ParentByToken } from "@/pages/Parent";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Users from "@/pages/admin/Users";
import LoginHistory from "@/pages/admin/LoginHistory";
import SchoolPage from "@/pages/directeur/SchoolPage";
import Classes from "@/pages/shared/Classes";
import Students from "@/pages/shared/Students";
import StudentFiches from "@/pages/shared/StudentFiches";
import StudentsStats from "@/pages/shared/StudentsStats";
import Subjects from "@/pages/maitre/Subjects";
import Notes from "@/pages/maitre/Notes";
import Evaluations from "@/pages/maitre/Evaluations";
import VieScolaire from "@/pages/shared/VieScolaire";
import Settings from "@/pages/shared/Settings";
import EspaceEnseignants from "@/pages/shared/EspaceEnseignants";
import Finance from "@/pages/directeur/Finance";
import "@/App.css";

function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="p-8 text-slate-500">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/inscription" element={<Register />} />
          <Route path="/parent" element={<ParentEntry />} />
          <Route path="/parent/card/:token" element={<ParentByToken />} />
          <Route path="/parent/:matricule" element={<ParentFiche />} />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="users" element={<ProtectedRoute roles={["admin", "directeur"]}><Users /></ProtectedRoute>} />
            <Route path="users/new" element={<ProtectedRoute roles={["admin"]}><Register adminMode /></ProtectedRoute>} />
            <Route path="registrations" element={<ProtectedRoute roles={["admin"]}><Registrations /></ProtectedRoute>} />
            <Route path="history" element={<ProtectedRoute roles={["admin"]}><LoginHistory /></ProtectedRoute>} />
            <Route path="activity" element={<ProtectedRoute roles={["admin"]}><Activity /></ProtectedRoute>} />
            <Route path="assiduite" element={<ProtectedRoute roles={["directeur", "maitre", "inspecteur"]}><Assiduite /></ProtectedRoute>} />
            <Route path="school" element={<ProtectedRoute roles={["directeur", "admin", "maitre"]}><SchoolPage /></ProtectedRoute>} />
            <Route path="classes" element={<Classes />} />
            <Route path="students" element={<Students />} />
            <Route path="students/fiches" element={<StudentFiches />} />
            <Route path="students/stats" element={<StudentsStats />} />
            <Route path="subjects" element={<Subjects />} />
            <Route path="notes" element={<Notes />} />
            <Route path="evaluations" element={<Evaluations />} />
            <Route path="absences" element={<Navigate to="/app/assiduite?tab=absences" replace />} />
            <Route path="vie-scolaire" element={<VieScolaire />} />
            <Route path="finance" element={<ProtectedRoute roles={["directeur", "admin", "maitre"]}><Finance /></ProtectedRoute>} />
            <Route path="settings" element={<Settings />} />
            <Route path="espace-enseignants" element={<ProtectedRoute roles={["admin", "directeur", "maitre"]}><EspaceEnseignants /></ProtectedRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
